import React from "react";
import { FaCircleXmark } from "react-icons/fa6";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import LoadingButton from "../CustomComponents/LoadingButton";

const ViewModal = ({ handleClose, heading, children }) => {
  return (
    <div>
      <ModalContainer handleClose={handleClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between">
            <p className="fs-4 fw-medium m-0">{heading}</p>
            <span className="bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                size={25}
                role="button"
                onClick={handleClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div
            className={`d-flex flex-column align-items-start justify-content-start w-100 ${cssStyles.children}`}
          >
            {children}
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ViewModal;
